import 'react-perfect-scrollbar/dist/css/styles.css'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import 'react-quill/dist/quill.snow.css'
import 'nprogress/nprogress.css'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom'
import { SnackbarProvider } from 'notistack'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import { Provider as ReduxProvider } from 'react-redux'
import LocalizationProvider from '@material-ui/lab/LocalizationProvider'
import AdapterDateFns from '@material-ui/lab/AdapterDateFns'
import StyledEngineProvider from '@material-ui/core/StyledEngineProvider'
import App from './App'
import { AuthProvider } from './contexts/Auth0Context'
import { SettingsProvider } from './contexts/SettingsContext'
import store from './store'
import { isElectron } from './utils/common'
import './index.css'

let ipcRenderer = null

if (isElectron()) {
  ipcRenderer = window.require("electron").ipcRenderer
  ipcRenderer.on('tel', (event, message) => {
    const e = new CustomEvent('tel', { detail: message.replace(/\D/g, '') })
    document.getElementById('root').dispatchEvent(e)
  })
}

ReactDOM.render(
  <StrictMode>
    <HelmetProvider>
      <ReduxProvider store={store}>
        <StyledEngineProvider injectFirst>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <SettingsProvider>
              {
                isElectron() ? (
                  <HashRouter>
                    <SnackbarProvider
                      dense
                      maxSnack={3}
                    >
                      <AuthProvider>
                        <App />
                      </AuthProvider>
                    </SnackbarProvider>
                  </HashRouter>
                )
                  : (
                    <BrowserRouter>
                      <SnackbarProvider
                        dense
                        maxSnack={3}
                      >
                        <AuthProvider>
                          <App />
                        </AuthProvider>
                      </SnackbarProvider>
                    </BrowserRouter>
                  )
              }
            </SettingsProvider>
          </LocalizationProvider>
        </StyledEngineProvider>
      </ReduxProvider>
    </HelmetProvider>
  </StrictMode>,
  document.getElementById('root')
)
